import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {select} from "application/store";
import {useHistory, useParams} from "react-router-dom";
import {Loading} from "../components";
import AuthService from "infrastructure/common/auth";

const AuthRoute = ({redirectTo}) => {
  const history = useHistory();
  const {ticket, reportId} = useParams();
  const dispatch = useDispatch();

  const state = useSelector(
    select((models) => ({
      userInfo: models.auth.user,
      isAuthenticated: models.auth.isAuthenticated
    }))
  );

  useEffect(() => {
    if (redirectTo && state.userInfo) {
      history.replace(redirectTo, { reportId });
      return;
    }

    if (ticket && !state.userInfo) {
      AuthService.persistAuthenticationToken(ticket);
      dispatch.auth.lookupUserInfoAction();
    }
  }, [ticket, state, history, redirectTo, dispatch]);

  return <Loading/>;
};

export default AuthRoute;
